import { generateStore } from "@/Utils/Store";
import OnboardingStateReducer, { OnboardingState } from "./reducers";
import OnboardingActionCreators from "./actions";
import { OnboardingProvider } from "./context";
const {
	withProvider: withOnboardingProvider,
	store: onbordingStore,
	useDispatch: useOnboardingDispatch,
	useSelector
} = generateStore<OnboardingState>(OnboardingStateReducer);
export const useOnboardingSelector = useSelector;
export {
	OnboardingActionCreators,
	OnboardingProvider,
	withOnboardingProvider,
	onbordingStore,
	useOnboardingDispatch
};
